import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {FormControl, FormGroup, FormGroupDirective, ReactiveFormsModule, Validators} from '@angular/forms';
import {AccountService} from '../../../../services/account/account.service';
import {AuthService} from '../../../../services/auth/auth.service';
import {LoaderService} from '../../../../services/loader/loader.service';
import {SnackbarService} from '../../../../services/snackbar/snackbar.service';
import {FormError} from '../../../../tools/form-error/form-error';
import {FormErrorComponent} from '../../../layout/form-error/form-error.component';
import {Config} from '../../../../models/config';
import {MetaTitle} from '../../../../decorator/meta-title';

@Component({
  selector: 'app-account',
  imports: [
    ReactiveFormsModule,
    FormErrorComponent
  ],
  templateUrl: './account.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './account.component.scss'
})
@MetaTitle('Account configuration')
export class AccountComponent implements OnInit {
  formPassword = new FormGroup({
    password: new FormControl('', [Validators.required]),
    passwordConfirm: new FormControl('', [Validators.required])
  });

  formPasswordError = new FormError();

  formTimezone = new FormGroup({
    timezone: new FormControl('')
  });

  constructor(
    private loader: LoaderService,
    private snackbar: SnackbarService,
    private accountService: AccountService,
    private auth: AuthService
  ) {
  }

  ngOnInit(): void {
    this.formPassword.get('password')?.setErrors({plop: true})

    const config = this.auth.getConfig();
    if (config) {
      this.setTimezoneFromConfig(config);
    } else {
      this.auth.getAsyncConfig().subscribe((config: Config | null) => this.setTimezoneFromConfig(config));
    }
  }

  setTimezoneFromConfig(config: Config | null): void {
    const timezone = config?.timezone;
    this.formTimezone.get('timezone')?.setValue(timezone === null || timezone === undefined ? '' : String(timezone));
  }

  onTimezoneSubmit(): void {
    const value = this.formTimezone.value.timezone;
    const timezone = value === '' || value === null || value === undefined ? null : parseInt(value, 10);

    this.loader.startLoading();
    this.accountService.saveTimezone(timezone).subscribe({
      next: () => {
        this.loader.stopLoading();
        this.snackbar.success('Your timezone has been updated successfully.');
        this.auth.loadConfig(true);
      },
      error: (error) => {
        this.loader.stopLoading();
        this.snackbar.error('An error occurred while saving your timezone.', error);
      }
    });
  }

  onPasswordSubmit(form: FormGroupDirective): void {
    this.formPasswordError.clearErrors();
    this.formPasswordError.setFormGroupErrors(this.formPassword);

    if (!this.formPassword.valid) {
      return;
    }

    const data: any = this.formPassword.value;

    this.loader.startLoading();
    this.accountService.changePassword(data.password).subscribe({
      next: () => {
        this.loader.stopLoading();
        this.snackbar.success('Your password has been updated successfully.')
        form.resetForm();
      },
      error: (error) => {
        this.formPasswordError.setApiResponseErrors(error);
      }
    });
  }
}
